import React, { useState } from 'react'
import { Switch } from '@softwaredev_cegeka/stix-form'
import { DataTableSortableHeader } from '@softwaredev_cegeka/stix-data-table'
import { Menu } from '@softwaredev_cegeka/stix-core/dist/components'
import { sortData, sortObjectToString } from 'src/utils/utils'

import './entityTable.scss'
import { withRouter } from 'react-router-dom'
import EntityTable from './EntityTable'

/**
 * User table content.
 * @param props
 * @returns {*}
 * @constructor
 */
function UserTable(props) {
    const { data, rowSelectHandler, setParams, params, deleteAction, ...rest } =
        props
    let [sort, setSort] = useState({ column: null, direction: null })
    const columns = [
        {
            Header: () => {
                return (
                    <DataTableSortableHeader
                        sorted={
                            sort.column === 'first_name'
                                ? sort.direction
                                : undefined
                        }
                        onSort={handleColumnSort('first_name')}
                    >
                        First Name
                    </DataTableSortableHeader>
                )
            },
            accessor: 'first_name',
            width: '10%',
        },
        {
            Header: () => {
                return (
                    <DataTableSortableHeader
                        sorted={
                            sort.column === 'last_name'
                                ? sort.direction
                                : undefined
                        }
                        onSort={handleColumnSort('last_name')}
                    >
                        Last Name
                    </DataTableSortableHeader>
                )
            },
            accessor: 'last_name',
            width: '10%',
        },
        {
            Header: () => {
                return (
                    <DataTableSortableHeader
                        sorted={
                            sort.column === 'email' ? sort.direction : undefined
                        }
                        onSort={handleColumnSort('email')}
                    >
                        Email
                    </DataTableSortableHeader>
                )
            },
            accessor: 'email',
            width: '20%',
        },
        {
            Header: 'Tenant',
            accessor: 'tenants',
            Cell: ({ cell }) => {
                return cell.value
                    ? cell.value.map(tenant => tenant.tenant).join(', ')
                    : ''
            },
            width: '10%',
        },
        {
            Header: () => {
                return (
                    <DataTableSortableHeader
                        sorted={
                            sort.column === 'is_global_admin'
                                ? sort.direction
                                : undefined
                        }
                        onSort={handleColumnSort('is_global_admin')}
                    >
                        Global admin
                    </DataTableSortableHeader>
                )
            },
            disableFilters: true,
            accessor: 'is_global_admin',
            Cell: ({ cell }) => {
                const switchProps = {
                    checked: cell.value ? true : null,
                    disabled: true,
                    srOnly: true,
                    label: 'Global admin',
                }
                return <Switch {...switchProps} />
            },
            width: '8%',
        },
        {
            Header: () => {
                return (
                    <DataTableSortableHeader
                        sorted={
                            sort.column === 'is_local_user'
                                ? sort.direction
                                : undefined
                        }
                        onSort={handleColumnSort('is_local_user')}
                    >
                        Local User
                    </DataTableSortableHeader>
                )
            },
            disableFilters: true,
            accessor: 'is_local_user',
            Cell: ({ cell }) => {
                const switchProps = {
                    checked: cell.value ? true : null,
                    disabled: true,
                    srOnly: true,
                    label: 'Local User',
                }
                return <Switch {...switchProps} />
            },
            width: '8%',
        },
        {
            Header: () => null,
            id: 'menu',
            Cell: selectedRow => (
                <Menu.Option
                    contextMenu={[
                        {
                            name: 'Edit user',
                            icon: 'edit',
                            onClick: () => {
                                props.history.push(
                                    '/user-form/' +
                                        selectedRow.row.original.username
                                )
                            },
                        },
                        {
                            name: 'See details',
                            icon: 'info',
                            onClick: () => {
                                rowSelectHandler(selectedRow)
                            },
                        },
                        {
                            name: 'Remove',
                            icon: 'delete',
                            onClick: () => {
                                let r = window.confirm(
                                    `You are permanently removing user ${selectedRow.row.original.first_name} ${selectedRow.row.original.last_name}. Are you sure?`
                                )
                                if (r === true) {
                                    deleteAction(
                                        selectedRow.row.original.username
                                    )
                                }
                            },
                        },
                    ]}
                    icon={'actions-vert'}
                />
            ),
            width: '1%',
        },
    ]
    const columnsToFilter = [
        {
            column: 'first_name',
            label: 'first name',
        },
        {
            column: 'last_name',
            label: 'last name',
        },
        {
            column: 'email',
        },
        {
            column: 'tenants',
        },
    ]

    const handleColumnSort = columnName => sortingDirection => {
        sortData(columnName, sortingDirection, params, setSort, setParams)
    }

    function handleFilterChange(entries) {
        // Reset to show al results after clear filters is clicked.
        if (entries.length === 0) {
            setParams({})
            return
        }

        const sortString = sortObjectToString(sort)

        // Update params with new selected filter and send them back to the route.
        entries.forEach(item => {
            Object.entries(item).forEach(([key, value]) => {
                params[key + '_like'] = value.toString()
            })
        })

        if (sortString) {
            params.sort = sortString
        }

        setParams(params)
    }

    function handleGlobalFilter(value) {
        const [part1, ...parts] = value.trim().split(' ')

        const searchParams = {
            ...params,
            use_or: parts.length < 1,
            first_name_like: part1,
            last_name_like: parts.length > 0 ? parts.join(' ') : part1,
        }
        setParams(searchParams)
    }

    if (process.env.REACT_APP_ENABLE_SUPPLIER_FUNCTIONALITY === 'true') {
        columns.push({
            Header: 'Supplier',
            accessor: 'suppliers',
            width: '10%',
            //todo
        })
    }

    return (
        <EntityTable
            {...rest}
            onSingleRowSelect={selectedRowObj => {
                rowSelectHandler(selectedRowObj)
            }}
            data={data}
            columns={columns}
            columnsTofilter={columnsToFilter}
            onColumnFilter={handleFilterChange}
            onGlobalFilter={handleGlobalFilter}
        />
    )
}

export default withRouter(UserTable)
